import { keyframes } from 'styled-components';
export const verticalFadeIn = (isTop) => keyframes `
  from {
    opacity: 0;
    ${isTop ? 'margin-bottom: -10px' : 'margin-top: -10px'};
  }

  to {
    opacity: 1;
    ${isTop ? 'margin-bottom: 0' : 'margin-top: 0'};
  }
`;
export const verticalFadeOut = (isTop) => keyframes `
  from {
    opacity: 1;
    ${isTop ? 'margin-bottom: 0' : 'margin-top: 0'};
  }
  to {
    opacity: 0;
    ${isTop ? 'margin-bottom: 10px' : 'margin-top: 10px'};
  }
`;
